// Threshold for scroll up actions to trigger nav state change
export const AD_SCROLL_THRESHOLD = 150
export const HEADER_SCROLL_THRESHOLD_DESKTOP = 1000
export const HEADER_SCROLL_THRESHOLD_MOBILE = 500

// Threshold for a scroll up event to register
export const SCROLL_CHANGE_THRESHOLD = 10
